import { v4 as uuidv4 } from 'uuid';

export function ProductSummaryImage(props = {}, childrenComponents = []) {
	return {
		componentName: 'ProductSummaryImage',
		componentId: uuidv4(),
		props: Object.assign(
			{
				showBadge: false,
				maxHeight: 300,
				hoverImage: {
					criteria: 'index',
					label: '',
					labelMatchCriteria: 'exact',
					index: 1,
				},
			},
			props,
		),
		childrenComponents,
	};
}
